module.exports = __webpack_public_path__ + "warning2.png?0a978e012a7c42fc4a3d84948280644c";